import script from "./RoleManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleManager.vue?vue&type=script&setup=true&lang=ts"

import "./RoleManager.vue?vue&type=style&index=0&id=3ed78b80&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ed78b80"]])

export default __exports__